const initSwiper = (element) => {
  if (element.swiper) element.swiper.destroy();

  const desktopSlides = parseFloat(element.getAttribute('data-desktop-slides') || '4');
  const tabletSlides = parseFloat(element.getAttribute('data-tablet-slides') || '3');
  const mobileSlides = parseFloat(element.getAttribute('data-mobile-slides') || '2');

  new Swiper(element, {
    direction: 'horizontal',
    loop: true,
    spaceBetween: 10,
    breakpoints: {
      0: {
        slidesPerView: mobileSlides,
        spaceBetween: 10, 
      },
      750: {
        slidesPerView: tabletSlides,
        spaceBetween: 10,
      },
      1200: {
        slidesPerView: desktopSlides,
        spaceBetween: 10,
      },
    },
  });
};

const initProductSlider = () => {
  const elements = document.querySelectorAll('.block__product-slider');
  
  elements.forEach((element) => {
    const sortBy = element.getAttribute('data-sort-by');
    const isBestSelling = element.getAttribute('data-is-best-selling') === 'true';
    const collectionHandle = element.getAttribute('data-collection-handle');
    const sectionId = element.getAttribute('data-section-id');

    if (sortBy === 'best-selling' && !isBestSelling && collectionHandle) {
      fetch(`/collections/${collectionHandle}?sort_by=best-selling&section_id=${sectionId}`)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newSlider = doc.querySelector(`[data-section-id="${sectionId}"]`);
          if (newSlider) {
            element.innerHTML = newSlider.innerHTML;
            element.setAttribute('data-is-best-selling', 'true');
            initSwiper(element);
          }
        })
        .catch(error => console.error('Error fetching best-selling products:', error));
      return;
    }

    if (element.swiper) return;
    initSwiper(element);
  });
};
 
// Initialize on load
initProductSlider();

// Handle re-initialization in Shopify Theme Editor
document.addEventListener('shopify:section:load', initProductSlider);

